import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '../tools/withStyles';
import { Link } from '../components/Link';
import { Main } from '../components/Main';
import { Text } from '../components/Text';
import { Fader } from '../components/Fader';
import { Secuence } from '../components/Secuence';
import joshMullisImageURL from '../images/eleksyonph.jpg';
import circadianAlgorithmImageURL from '../images/circadian-algorithm.png';

const styles = theme => ({
  root: {}
});

class About extends React.Component {
  static propTypes = {
    classes: PropTypes.object
  };

  render () {
    const { classes } = this.props;

    return (
      <Main className={classes.root}>
        <article>
          <Secuence stagger>
            <header>
              <h1><Text>About EleksyonPH</Text></h1>
            </header>
            <p><Text>ElectionPH is a fully interactive and publicly accessible web application designed to visualize Philippine election results at different administrative scales. It aims to provide transparency, ease of exploration, and a dynamic user experience, allowing anyone to explore detailed election data in an intuitive, data-driven environment.</Text></p>
            <Fader>
              <img src={joshMullisImageURL} alt="eleksyonphdemo" />
            </Fader>
            <p><Text>The application operates through three primary modes, each representing a distinct administrative level. Every dataset, popup, chart, and search index dynamically changes depending on the active mode: Barangay Mode, Municipality Mode, and Provincial Mode.</Text></p>
            <Link
              href='https://zaxatlas.site/'
              target='circalgorithm'
              style={{ display: 'block' }}
            >
              <Fader style={{ display: 'block' }}>
                <img
                  src={circadianAlgorithmImageURL}
                  alt='eleksyonph logo'
                  style={{ width: '100%', maxWidth: '400px' }}
                />
              </Fader>
            </Link>
            <Fader>
              <h2>Modes of Operation</h2>
              <p><strong>Barangay Mode:</strong> When Barangay Mode is activated, the map loads the barangay pmtiles. All interface components — including attribute popups, chart popups, and right-click popups — adapt automatically to barangay-level attributes. The search bar retrieves results only from barangay datasets, ensuring accurate level-specific results.</p>
              <p><strong>Municipality Mode:</strong> When Municipality Mode is selected, MapLibre automatically fetches the municipality-level GeoJSONs and renders them natively on the map. All UI components adapt dynamically to display municipality-specific data, with charts displaying pre-summarized data from the GeoJSON attributes.</p>
              <p><strong>Provincial Mode:</strong> When Provincial Mode is activated, MapLibre fetches the provincial-level GeoJSONs and renders them natively. The map's symbology, popups, and search behavior automatically update to show province-level election data, with all visualizations based on pre-calculated summaries in the dataset.</p>
              <h2>Dynamic Behavior</h2>
              <p>ElectionPH is built on a mode-aware architecture, meaning every component automatically adjusts to the active administrative level. The dataset loader switches sources depending on mode, attribute and chart popups display mode-specific fields and statistics, and the search function limits results to the current mode scope.</p>
              <h2>Design and Accessibility</h2>
              <p>The web app is public-facing. It's designed purely for viewing and data interaction, with responsive UI elements that automatically resize on mobile and desktop devices. The interface aims to balance clarity and aesthetic appeal for both casual viewers and data enthusiasts.</p>
              <h2>Credits</h2>
              <p><strong>Developer:</strong> Zax Atlas<br/>
              <strong>GIS Platform:</strong> MapLibre<br/>
              <strong>Data Sources:</strong> Processed GeoJSONs from official COMELEC election results<br/>
              <strong>Design Inspiration:</strong> Cyberpunk, Science Fiction</p>
              <p style={{ margin: 0 }}>Last updated: November 2025</p>
            </Fader>
          </Secuence>
        </article>
      </Main>
    );
  }
}

export default withStyles(styles)(About);
